import { LanguageState } from './language/language.state';

export * from './language';
export const ecologyState = [
    LanguageState
];